<template>
  <div>
    <div class="row">
      <div class="col name">
        <span>{{salary.name}}</span>
      </div>
      <div class="col-4 value">{{details.sum | currency}}</div>
    </div>

    <div class="row description" v-if="salary.description">{{salary.description}}</div>

    <div class="row">
      <div class="row col">
        <div class="col-3">Days: {{details.days}}</div>
        <div class="col-3">Hours per day: {{details.hoursPerDay || 8}}</div>
        <div class="col-3">Hours: {{salary.hours}}</div>
        <div class="col-3">Value per hour: {{salary.value / salary.hours | currency}}</div>
      </div>
      <div class="col-4">{{details.valuePerMonth | currency}}</div>
    </div>

    <div v-if="salary.months && salary.months.length">{{salary.months | months}}</div>

    <div class="row" v-for="overtime in salary.overtimes" v-bind:key="overtime.id">
      <Overtime class="col" v-bind:overtime="overtime"></Overtime>
      <div class="col-4">{{overtimeValue(overtime) | currency}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["salary"],
  computed: {
    details() {
      let details = this.$piggyBank.data.salaryDetails(this.salary);
      return details;
    },
  },
  methods: {
    overtimeValue(overtime) {
      return (overtime.percent * overtime.hours * this.details.valuePerHour) / 100;
    }
  }
};
</script>